<div class="container">
    <h2 class="text-center mb-5"><strong>Trending Properties</strong></h2>
</div>
<div class="container" *ngIf="!loaded">
    <div class="row justify-content-center mt-5 mb-5">
        <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
    </div>
</div>
<div class="container" *ngIf="propertyList.length > 0">
    <div class="row justify-content-center">
        <div class="col-12 col-sm-12 col-md-6 col-lg-3 mt-1 mb-4" *ngFor="let property of propertyList">
            <a [routerLink]="['/property/'+property.id]">
                <div class="prop-contents">
                    <div class="cont-image">
                        <img [src]="property.featuredImage">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title mb-4">
                            {{ property.title }}
                        </p>
                        <p><img style="display: inline; margin-right: 5px;" src="assets/location_small.png">{{ property.address }}</p>
                        <p class="property-price">रु {{ property.price }}</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
    <div class="see-more d-flex justify-content-center mt-5" style="font-size: medium;">
        <a class="custom-button" [routerLink]="['/properties']">
            All Properties <i class="ml-2 fas fa-arrow-right"></i>
        </a>
    </div>
</div>
